import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchingSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';
import config from 'apex-web/lib/config';
import BalancesListComponent from './BalancesListComponent';
import { selectBalancesWithPrices } from '../../redux/selectors/balancesWithPrices';

const mapStateToProps = state => {
  const { theme } = config.global;
  const localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};
  const currentTheme = localConfig.theme || theme;
  return {
    fetching: fetchingSelector(state),
    balances: selectBalancesWithPrices(state),
    isDarkTheme: currentTheme === 'dark'
  };
};

const BalancesListContainer = connect(mapStateToProps)(BalancesListComponent);

BalancesListContainer.defaultProps = {
  isBasicView: false,
  t: s => s
};

BalancesListContainer.propTypes = {
  isBasicView: PropTypes.bool,
  t: PropTypes.func
};

export default BalancesListContainer;
